import React, { useContext, useState, useEffect } from "react";
import {
  Root,
  Tittle,
  Column,
  CssTextField,
  Button,
  OneColumn,
  Container,
  CssNativeSelect,
  OptionSelect,
} from "./style";
import SaveIcon from "@mui/icons-material/Save";
import { FormControl, InputLabel, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import Wait from "../../../../Wait";

const UpdateContactnformation = () => {
  const { accounts } = useMsal();
  const { t } = useTranslation();
  const {
    primaryContact,
    updateContactAX,
    updateContactAD,
    getContactInformation,
  } = useContext(ContactContext);

  const [load, setLoad] = useState(false);
  const [personalInfoLocal, setPersonalInfoLocal] = useState({
    name: primaryContact.givenName,
    lastName: primaryContact.surname,
    email: accounts[0].idTokenClaims.emails[0],
    liActiveDirectoryGuid: accounts[0].localAccountId,
  });
  const setInfo = (event) => {
    setPersonalInfoLocal((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const updatePersonalInfo = async () => {
    console.log(personalInfoLocal);
    setLoad(true);
    const data = {
      liActiveDirectoryGuid: personalInfoLocal.liActiveDirectoryGuid,
      firstName: personalInfoLocal.name,
      lastName: personalInfoLocal.lastName,
      middleName: personalInfoLocal.name,
    };
    var respAX = await updateContactAX(data);
    var respAD = await updateContactAD(data);
    await getContactInformation(personalInfoLocal.liActiveDirectoryGuid);
    setLoad(false);
  };

  return (
    <Root>
      {load && <LinearProgress color="error" />}

      {Object.keys(primaryContact).length === 0 || load ? (
        <Wait />
      ) : (
        <form onSubmit={updatePersonalInfo}>
          <Tittle>{t("updtInfo")}</Tittle>
          <Container>
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                value={personalInfoLocal.name}
                fullWidth
                label={t("name")}
                id="name"
                name="name"
                onChange={(e) => setInfo(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                value={personalInfoLocal.lastName}
                fullWidth
                label={t("lastName")}
                id="lastName"
                name="lastName"
                onChange={(e) => setInfo(e)}
              />
            </Column>
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                value={personalInfoLocal.email}
                fullWidth
                label={t("email")}
                id="email"
                name="email"
                disabled={true}
                onChange={(e) => setInfo(e)}
              />
            </Column>
          </Container>
          <Container>
            <OneColumn>
              {/* <Button onClick={() => updatePersonalInfo()}> */}
              <Button type="submit">
                {t("update")} <SaveIcon />
              </Button>
            </OneColumn>
          </Container>
        </form>
      )}
    </Root>
  );
};

export default UpdateContactnformation;
